// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.button__active {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__active.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__active {
    width: 60px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__noactive {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__noactive.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__noactive {
    width: 80px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__nodesigner {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__nodesigner.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__nodesigner {
    width: 40px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__inprogress {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__inprogress.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__inprogress {
    width: 70px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__completed {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__completed.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__completed {
    width: 50px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}

.planning__search {
  height: 30px;
  width: 100px;
  font-size: 14px;
  outline: none;
}
@media (max-width: 460px) {
  .planning__search {
    display: none;
  }
}

.planning__search.mobile {
  display: none;
}
@media (max-width: 460px) {
  .planning__search.mobile {
    display: block;
    width: 150px;
    height: 20px;
    font-size: 10px;
    margin-top: 15px;
  }
}

.planning-table-container {
  position: relative;
  margin-top: 20px;
  overflow: hidden;
  height: calc(100vh - var(--header-height, 150px));
}
@media (max-width: 768px) {
  .planning-table-container {
    height: calc(100vh - var(--header-height, 250px));
  }
}

.planning-table-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #dee2e6;
  overscroll-behavior: contain;
}

.planning-th {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
}

.planning-th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-bottom: 2px solid #dee2e6;
  width: 100%;
}

.planning-th.mobile {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: white !important;
  text-align: center;
}

.planning-th.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-bottom: 2px solid #dee2e6;
  width: 100%;
}

.planning-td.mobile {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
@media (max-width: 1024px) {
  .planning-td.mobile {
    background-color: #ffffff !important;
  }
}

.planning-td.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0px;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}`, "",{"version":3,"sources":["webpack://./src/components/PlanningList/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AADI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAGR;AADI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAIN;AACF;;AAAA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAGJ;AAFI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAIR;AAFI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAKN;AACF;;AADA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAIJ;AAHI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAKR;AAHI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAMN;AACF;;AAFA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAKJ;AAJI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAMR;AAJI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAON;AACF;;AAHA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAMJ;AALI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAOR;AALI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAQN;AACF;;AAJA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAOJ;;AAJA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACC,aAAA;AAOL;AANK;EALL;IAOQ,aAAA;EAQN;AACF;;AAJA;EACI,aAAA;AAOJ;AANI;EAFJ;IAGQ,cAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EASN;AACF;;AANA;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;AASJ;AARI;EALJ;IAMQ,iDAAA;EAWN;AACF;;AARA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,yBAAA;EACA,4BAAA;AAWJ;;AAHA;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AAMJ;;AAFA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAKJ;;AADA;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,kBAAA;AAIJ;;AADA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAIJ;;AADA;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AAIJ;AAHI;EALJ;IAMQ,oCAAA;EAMN;AACF;;AAHA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAMJ","sourcesContent":[".button__active {\n    width: 150px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 60px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n        \n    }\n}\n\n.button__noactive {\n    width: 150px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 80px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n       \n    }\n}\n\n.button__nodesigner {\n    width: 150px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 40px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n       \n    }\n}\n\n.button__inprogress {\n    width: 150px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 70px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n       \n    }\n}\n\n.button__completed {\n    width: 150px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 50px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n       \n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}\n\n.planning__search {\n    height: 30px;\n    width: 100px;\n    font-size: 14px;\n     outline: none; \n     @media(max-width: 460px) {\n        \n        display: none;\n     }\n\n}\n\n.planning__search.mobile {\n    display: none;\n    @media(max-width: 460px) {\n        display: block;\n        width: 150px;\n        height: 20px;\n        font-size: 10px;\n        margin-top: 15px;\n    }\n}\n\n.planning-table-container {\n    position: relative;\n    margin-top: 20px; \n    overflow: hidden;\n    height: calc(100vh - var(--header-height, 150px));\n    @media(max-width: 768px) {\n        height: calc(100vh - var(--header-height, 250px));\n    }\n}\n  \n.planning-table-wrapper {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    border: 1px solid #dee2e6;\n    overscroll-behavior: contain;\n  \n   \n  \n}\n\n\n    \n.planning-th {\n    padding: 5px !important;\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    background-color: white !important; \n    \n}\n\n.planning-th::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-bottom: 2px solid #dee2e6;\n    width: 100%;\n    \n}\n\n.planning-th.mobile {\n    padding: 5px !important;\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 4;\n    background-color: white !important; \n    text-align: center;\n}\n\n.planning-th.mobile::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-bottom: 2px solid #dee2e6;\n    width: 100%;\n}\n\n.planning-td.mobile {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    @media(max-width: 1024px) {\n        background-color: #ffffff !important;\n    }\n}\n\n.planning-td.mobile::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0px;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
